import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InfoBannerComponent } from "./info-banner.component";
import { IonicModule } from "@ionic/angular";

@NgModule({
  declarations: [InfoBannerComponent],
  exports: [InfoBannerComponent],
  imports: [CommonModule, IonicModule],
})
export class InfoBannerModule {}
